export type UpdatePartnersDeletionFlagsRequest = {
  ptnrList: DeleteTargetPartnerInfo[];
};

export type DeleteTargetPartnerInfo = {
  index: number;
  ptnrId: String;
  delFlg: String;
  updtDtimePtnr: String;
};
